<template>
  <v-form ref="form" >
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12">
        <v-switch v-if="!this.extraData.accountContext.accountPermissions.isAltavenda"
          v-model="entry.isNewItemInStorage" 
          @change="isNewItemInStorageChanged"
          inset 
          :disabled="readOnly"
          :label="entry.isNewItemInStorage ? 'Lista todos os produtos' : 'Lista somente produtos em depósito'"
        >
        </v-switch>
      </v-col>

      <template v-if="entry.isNewItemInStorage && !this.extraData.accountContext.accountPermissions.isAltavenda">
        <v-col cols="12">
          <v-autocomplete
            v-model="entry.itemId"
            v-bind="getObject('itemId')"
            label="Produto"
            :items="endProductsList"
            item-value="id"
            item-text="name"
            :search-input.sync="productsSearch"
            no-filter
            @input="selectItemNewInStorage"
            no-data-text="Nenhum Produto encontrado, faça outra busca"
            :hint="entry.item ? ( 'Unidade de Produção: ' + entry.item.unit.name + (entry.item.brand ? ', Marca: ' + entry.item.brand.name : '')) : ''"
            persistent-hint
            autocomplete="off"
            :disabled="readOnly"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            :disabled="!entry.itemId || readOnly"
            v-model="entry.packagingId"
            v-bind="getObject('packagingId')"
            label="Embalagem"
            :items="packagingList"
            item-value="id"
            item-text="name"
            :hint="entry.itemWeight && entry.itemWeight.grossWeight && entry.itemWeight.liquidWeight ? 'Peso B: ' + (entry.itemWeight.grossWeight+' KG' + ' - Peso L: ' + entry.itemWeight.liquidWeight)+' KG' : '' "
            persistent-hint
            @input="selectPackagingNewInStorage"
            :loading="packagingListLoading"
            autocomplete="off"
          >

          <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>Pesos</v-list-item-title>
                <v-list-item-subtitle>Peso B: {{data.itemWeight ? data.itemWeight.grossWeight : '0'}}, Peso L: {{ data.itemWeight ? data.itemWeight.liquidWeight : '0' }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
            
          </v-autocomplete>
        </v-col> 

        <v-col cols="12">
          <v-autocomplete
            v-model="entry.storageId"
            v-bind="getObject('storageId')"
            label="Depósito"
            :items="extraData.accountContext.allStorages"
            item-value="id"
            item-text="name"
            @input="selectStorageFromAllStorages"
            :hint="entry.storage ? 'Localização: ' + (entry.storage.location ? entry.storage.location : 'não informada') : '' "
            persistent-hint
            autocomplete="off"
            clearable
            @click:clear="$nextTick(() => entry.storageId = null)"
            :disabled="readOnly"
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>{{data.item.name}}</v-list-item-title>
                <v-list-item-subtitle>Localização: {{data.item.location ? data.item.location : 'não informada'}}</v-list-item-subtitle>
              </v-list-item-content>
            </template>

            <template v-slot:append-outer>
              <StorageNew
                :inlineAddButton="true"
                @entry-created="storageCreated"
              />
            </template>
          </v-autocomplete>
        </v-col>

      </template>

      <template v-else>

        <template v-if="this.extraData.accountContext.accountPermissions.isAltavenda">
          <v-col cols="12">
          <v-autocomplete
            :disabled="readOnly"
            v-model="entry.itemId"
            v-bind="getObject('itemId')"
            label="Produto"
            :items="itemsList"
            item-value="id"
            item-text="name"
            :search-input.sync="itemsSearch"
            @input="getPackagingsForItem"
            :loading="itemsListLoading"
            autocomplete="off"
          >
          </v-autocomplete>
        </v-col>

        </template>
      
        <template v-else>
          <!-- lista somente os produtos em storage -->
            <v-col cols="12">
            <v-autocomplete
              v-model="entry.itemId"
              v-bind="getObject('itemId')"
              label="Produto"
              :items="extraData.accountContext.availableItemsForSale"
              item-value="id"
              item-text="name"
              @input="selectItemInStorage(true)"
              :hint="entry.item ? ( 'Unidade de Produção: ' + entry.item.unit.name + (entry.item.brand ? ', Marca: ' + entry.item.brand.name : '')) : ''"
              persistent-hint
              autocomplete="off"
              :disabled="readOnly"
            >
            </v-autocomplete>
          </v-col>
        </template>

        <v-col cols="12">
          <v-autocomplete
            :disabled="!entry.itemId || readOnly"
            v-model="entry.packagingId"
            v-bind="getObject('packagingId')"
            label="Embalagem"
            :items="packagingList"
            item-value="id"
            item-text="name"
            @input="selectPackagingInStorage"
            :loading="packagingListLoading"
            autocomplete="off"
            :hint="entry.itemWeight && entry.itemWeight.grossWeight && entry.itemWeight.liquidWeight ? 'Peso B: ' + (this.toLocalString(entry.itemWeight.grossWeight) + '- Peso L: ' + this.toLocalString(entry.itemWeight.liquidWeight)) : '' "
            persistent-hint
          >
            <!-- <template v-slot:append-outer>
              <PackagingNew
                :inlineAddButton="true"
                @entry-created="packagingCreated"
              />
            </template> -->
          </v-autocomplete>
        </v-col> 

        <!-- somente pega os storages do item se nao for item novo -->
        <v-col cols="12">
          <v-autocomplete
            :disabled="entry.itemId ? readOnly : true"
            v-model="entry.storageId"
            v-bind="getObject('storageId')"
            label="Depósito"
            :items="storageList"
            item-value="id"
            item-text="name"
            @input="selectStorageFromList"
            :loading="storageListLoading"
            :hint="entry.storage ? 'Quantidade disponível: ' + numberToDecimal(entry.storage.availableQuantity) + ' ' + entry.packaging.unitName : '' "
            persistent-hint
            autocomplete="off"
          >
            <!-- <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>{{data.item.name}}</v-list-item-title>
                <v-list-item-subtitle>Quantidade disponível: {{numberToDecimal(data.storage.availableQuantity)}}</v-list-item-subtitle>
              </v-list-item-content>
            </template> -->
          </v-autocomplete>
        </v-col>

      </template>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"
          :disabled="!entry.packagingId || readOnly"
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :suffix="entry.packaging ? entry.packaging.text : ''"
          :key="packagingQuantityKey"
        />
      </v-col>


      <v-col cols="12" sm="6" md="6" v-if="!this.extraData.accountContext.accountPermissions.isAltavenda">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade"
          :suffix="entry.packaging ? entry.packaging.unitName : ''"
          @update:inputData="changeQuantity"
          autocomplete="off"
          :disabled="readOnly"
          :key="quantityKey + 'quantity'"
        />
      </v-col>

      <!-- Preço da embalagem -->
      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingPrice"
          mask-type="currency_10d"
          label="Preço Embalagem"
          prefix="R$"
          :suffix="entry.packaging ? entry.packaging.text : ''"
          :disabled="(!entry.packagingId || readOnly || this.extraData.accountContext.accountPermissions.isSeller)"
          :key="packagingPriceKey + 'packagingPrice'"
          @update:inputData="changedPackagingPrice"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6" v-if="!this.extraData.accountContext.accountPermissions.isAltavenda">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('unitPrice')"
          :inputData.sync="entry.unitPrice"
          mask-type="currency_10d"
          label="Preço"
          prefix="R$"
          :key="unitPriceKey + '_unit_price'"
          @update:inputData="changeUnitPrice"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('discountPercent')"
          :inputData.sync="entry.discountPercent"
          mask-type="currency"
          label="Desconto %"
          :key="discountPercentKey + '_discount'"
          @update:inputData="changeDiscountPercent"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('discount')"
          :inputData.sync="entry.discount"
          mask-type="12v0-4"
          label="Desconto"
          :key="discountKey + '_unit_discount'"
          @update:inputData="changeDiscount"
          :hint="percentDiscount"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('price')"
          :inputData.sync="entry.price"
          mask-type="currency"
          label="Preço Total"
          prefix="R$"
          :key="totalPriceKey + '_total_price'"
          @update:inputData="changeTotalPrice"
          :hint="entry.priceWithDiscount"
          autocomplete="off"
          :disabled="readOnly || this.extraData.accountContext.accountPermissions.isAltavenda"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('totalDiscount')"
          :inputData.sync="entry.totalDiscount"
          mask-type="currency_10d"
          label="Desconto total"
          prefix="R$"
          :key="totalDiscountKey + '_total_discount'"
          autocomplete="off"
          :disabled="true"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
// import { SALE_PRODUCT_STORAGE_QUERY } from "@apollo/queries/models/saleProductQueries.js";
import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      endProductsList: [],
      itemsList: [],
      itemsListLoading: false,
      endProductsListLoading: false,
      entryAttributes: {},
      storageListLoading: false,
      storageList: [],
      renderComponent: true,
      unitPriceKey: 0,
      totalPriceKey: -1,
      quantityKey: 0,
      pageLoading: false,
      packagingListLoading: false,
      packagingList: [],
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      packagingPriceKey: 0,
      discountPercentKey: 0,
      productsSearch: "",
      itemsSearch: "",
      timer: null,
      tablePriceItem: null,
      priceWithoutDiscountKey: 0,
      totalDiscountKey: 0,
      discountKey:0,
      percentDiscount: ""
    };
  },
  props: {
    entry: Object,
    manualPackagingPrice: false,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  beforeCreate: function () {
    this.$options.components.StorageNew = require('@models/storages/new.vue').default
  },
  created() {
    // console.log("entry", this.entry);
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // this.getItems();
    if (this.entry.item) {
      if (this.entry.isNewItemInStorage) {
        this.endProductsList = [this.entry.item]
        this.selectItemNewInStorage();
      } else {
        this.selectItemInStorage();
      }
    }

    if(this.entry.itemAux){
      // console.log("item", this.entry.item);
      this.entry.item = this.entry.itemAux;
      this.itemsList.push(this.entry.itemAux);
    }
    // console.log(this.extraData);
    if(this.extraData.customerId && this.extraData.paymentConditionRuleId && this.entry.packagingId){
      // console.log("buscando");
      this.findTablePriceProduct();
    }

  },
  mounted() {
    // this.getItems();
  },
  computed: {
  },
  watch: {
    productsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch);
      // if (this.productsSearch && this.productsSearch.length > 0) {
      //   if (!this.entry.item || this.entry.item.name != this.productsSearch) {
      //     this.getEndProducts();
      //   }
      // }

      if (this.productsSearch && this.productsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.productsSearch) && newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.getEndProducts();
          }, 2000);
        }
      }
    },
    itemsSearch: function(newSearch, oldSearch) {
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.getItems();
          }, 2000);
        }
      }
    },
    "entry.packagingId": function(newValue, oldVal){
      // console.log("package change", this.extraData);
      if(this.extraData.customerId && this.extraData.paymentConditionRuleId && newValue){
        this.findTablePriceProduct();
        // this.updateQuantity();
      }
    },
  },
  methods: {
    changeQuantity: function() {
      this.entry.packagingQuantity = _.round(this.entry.quantity / this.entry.packaging.size, 10);
      this.packagingQuantityKey++;
      this.updateQuantity();
    },
    changePackagingQuantity: function() {
      this.entry.quantity = _.round(this.entry.packagingQuantity * this.entry.packaging.size, 10);
      this.quantityKey++;
      this.updateQuantity();
    },

    updateQuantity: function() {
      // console.log("quantity", this.entry.quantity);

      // console.log("packaging price", this.entry.packagingPrice);
      if (this.entry.unitPrice > 0) {
        this.calculatePackagingPrice();
        this.calculateTotalPrice();
      } else if (this.entry.price > 0) {
        this.calculateUnitPrice();
        this.calculatePackagingPrice();
      } else if(this.entry.packagingPrice > 0){
        this.calculateUnitPrice(false);
        this.calculateTotalPrice();
      } else {
        this.entry.totalPrice = 0;
        this.totalPriceKey--;
        this.entry.price = 0;
        this.unitPriceKey++;
        this.entry.packagingPrice = 0;
        this.packagingPriceKey++;
      }
    },
    changeDiscount: function(){
      var res = ((1-(this.getPackagingPrice(false) - this.entry.discount) / this.getPackagingPrice(false))*100);
      if(res && Number.isFinite(res)){
        this.percentDiscount = "Desconto de aproximadamente " + res.toLocaleString('pt-BR') + "%";
      }
      else{
        this.percentDiscount = "";
        this.entry.priceWithDiscount = "";
      }

      if(this.entry.discountPercent){
        this.entry.discountPercent=null;
        this.discountPercentKey++;
      }
      // this.discountKey++;
      this.calculateTotalPrice();
      // this.changeDiscount();
      // if(this.entry.packagingPrice){
      //   // this.entry.packagingPrice = this.getPackagingPrice(false);
      //   // this.entry
      //   // this.packagingPriceKey++;
      //   this.changePackagingPrice();
      // }else{
      //   // this.entry.packagingPrice = this.getPackagingPrice(false);
      //   // this.packagingPriceKey++;
      //   this.changePackagingPrice();
      // }
    },
    changeDiscountPercent: function(){
      var discounted = _.round((this.getPackagingPrice(false) * (1 - (this.entry.discountPercent) / 100)), 4);
      // console.log(this.getPackagingPrice(false));
      // console.log(discounted);
      this.entry.discount = _.round(this.getPackagingPrice(false) - discounted, 4);
      this.discountKey++;
      // this.percentDiscount = "";
      // this.calculateUnitPrice(false);
      this.calculateTotalPrice();
      
    },
    changeUnitPrice: function() {
      // console.log("unitPrice", this.entry.price);
      if (this.entry.quantity > 0) {
        this.calculatePackagingPrice();
        this.calculateTotalPrice();
      }
    },
    changedPackagingPrice: function(){
      console.log("manual change");
      this.manualPackagingPrice = true;
      if(this.tablePriceProduct){
        this.tablePriceProduct.value = this.entry.packagingPrice;
      }
      // this.calculatePackagingPrice();
      this.changePackagingPrice();
    },
    changePackagingPrice: function() {
      // console.log("chance packaging price");
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice(false);
        this.calculateTotalPrice();
      }
    },
    changeTotalPrice: function() {
      // console.log("totalPrice", this.entry.totalPrice);
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice();
        this.calculatePackagingPrice();
      }
    },
    calculateTotalPrice: function() {
      this.entry.price = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.quantity ? this.entry.quantity : 0), 2);
      this.totalPriceKey--;

      // if(this.tablePriceProduct){
        this.entry.priceWithoutDiscount = _.round((this.getPackagingPrice(false)) * (this.entry.packagingQuantity ? this.entry.packagingQuantity : 0), 2);
        this.priceWithoutDiscountKey++;
        this.entry.totalDiscount = _.round((this.entry.discount || 0) * this.entry.packagingQuantity, 2);
        this.totalDiscountKey++;
        if(this.entry.discount){
          this.entry.priceWithDiscount = "por: " + this.toLocalString(this.entry.price - this.entry.totalDiscount);
          this.entry.liquidPrice = this.entry.price - this.entry.totalDiscount;
        }else{
          this.entry.priceWithDiscount="";
        }
      // }
    },
    toLocalString: function(val){
      return val.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      });
    },
    calculateUnitPrice: function(byTotalPrice=true) {
      if (byTotalPrice) {
        this.entry.unitPrice = _.round((this.entry.price ? this.entry.price : 0) / (this.entry.quantity ? this.entry.quantity : 0), 10);
      } else { //calcula pelo preco unitario com base no preco da embalagem
        // console.log("pack", this.entry.packaging);
        if(this.tablePriceProduct){
          this.entry.unitPrice = _.round((this.getPackagingPrice(false)) / (this.entry.packaging.size ? this.entry.packaging.size : 0), 10);
        }else{
          this.entry.unitPrice = _.round(this.entry.packagingPrice / this.entry.packaging.size, 10);  
        }
        // console.log(this.entry.unitPrice);
      }
      this.unitPriceKey++;
    },
    calculatePackagingPrice: function() {
      if(!this.manualPackagingPrice){
        this.entry.packagingPrice = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.packaging.size ? this.entry.packaging.size : 0), 10);
        this.packagingPriceKey++;
      }
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    getPackagingPrice: function(withDiscount=true){
      if(this.tablePriceProduct && this.tablePriceItem && !this.isEdit){
        if(this.tablePriceItem.percentType == 0 && !this.manualPackagingPrice){
          // console.log("type1");
          return _.round((this.tablePriceProduct.value / (1 - this.tablePriceItem.percent/100)), 2);
        }else{
          // console.log("type0");
          var res = this.tablePriceProduct.value * (this.entry.discountPercent > 0 ? (1-(this.entry.discountPercent/100)) : 1)
          // console.log(res);
          if(withDiscount){
            return res;
          }else{
            return this.tablePriceProduct.value;
          }
        }
      }else{
        return this.entry.packagingPrice;
      }
    },
    isNewItemInStorageChanged: function () {
      this.endProductsList = [];
      this.entry.itemId = null;
      this.entry.packagingId = null;
      this.entry.quantity = null;
      this.entry.unitPrice = null;
      this.entry.price = null;
      this.unitPriceKey++; 
      this.totalPriceKey++; 
      this.productsSearch = ''; 
    },
    getEndProducts: function() {
      this.endProductsListLoading = true;
      this.$apollo
        .query({
          query: END_PRODUCTS_FOR_QUERY,
          variables: {
            query: this.productsSearch
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.endProductsList = response.data.accountGlobalSharedContext.allAvailableEndProductsForQuery;
          // console.log("getPurchaseItems", this.purchaseItemsList);
          // if (this.packageList.length == 1 && !this.entry.packageId) {
          //   this.entry.packageId = this.packageList[0].id;
          //   this.selectPackage();
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.endProductsListLoading = false));
    },

    getItems: function() {
      this.itemsListLoading = true;
      this.$apollo
        .query({
          query: ALL_ITEMS_QUERY,
          variables: {
            itemsSearch: this.itemsSearch,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.itemsList = response.data.accountContext.allItemsSearch;
          // console.log("items", this.itemsList);
        })
        .catch(response => console.log(response))
        .finally(() => (this.itemsListLoading = false));
    },
    selectItemNewInStorage: function() {
      this.entry.item = this.endProductsList.find(obj => obj.id == this.entry.itemId);
      this.packagingList = this.entry.item.packagings;

      if (!this.entry.packagingId && this.packagingList.length == 1) {
        this.entry.packagingId = this.packagingList[0].id;
        this.selectPackagingNewInStorage(); 
      }
    },
    selectPackagingNewInStorage: function(clearStorage=false) {
      if (this.entry.packagingId) {
        this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);

        if (this.extraData.accountContext.allStorages.length == 1 && !this.entry.storageId) {
          this.selectStorageFromAllStorages();
        }
      }
    },
    selectStorageFromAllStorages: function() {
      if (this.entry.storageId) {
        this.entry.storage = this.extraData.accountContext.allStorages.find(obj => obj.id == this.entry.storageId);        
      }
    },
    selectItemInStorage: function(clearPackagingAndStorage=false) {
      this.entry.item = this.extraData.accountContext.availableItemsForSale.find(obj => obj.id == this.entry.itemId);
      this.packagingList = [];

      if (clearPackagingAndStorage) {
        this.entry.packagingId = null;
        this.entry.packaging = null;
        this.entry.storageId = null;
        this.entry.storage = null;
      }
      this.packagingListLoading = true;
      this.$apollo
        .query({
          query: AVAILABLE_PACKAGINGS_FOR_SALE_ITEM_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            dummyExitMovementItemId: this.entry.id
          }
        })
        .then(response => {
          // console.log("response dos packaging", response);
          this.packagingList = response.data.accountContext.availableItemPackagingsForSale;
          let clearStorage = false;
          if (this.packagingList.length == 1 && !this.entry.packagingId) {
            this.entry.packagingId = this.packagingList[0].id;
            clearStorage = clearPackagingAndStorage;
          }
          this.selectPackagingInStorage(clearStorage);
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false));
    },
    getPackagingsForItem: function(clearPackagingAndStorage=false) {
      this.entry.item = this.itemsList.find(obj => obj.id == this.entry.itemId);
      this.packagingList = [];

      this.entry.itemWeight = {};

      if (clearPackagingAndStorage) {
        this.entry.packagingId = null;
        this.entry.packaging = null;
        this.entry.storageId = null;
        this.entry.storage = null;
      }
      this.packagingListLoading = true;
      this.$apollo
        .query({
          query: AVAILABLE_PACKAGINGS_FOR_ITEM_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            customerId: this.extraData.customerId,
          }
        })
        .then(response => {
          // console.log("response dos packaging", response);
          this.packagingList = response.data.accountContext.availablePackagingsForItem;
          // let clearStorage = false;
          // if (this.packagingList.length == 1 && !this.entry.packagingId) {
          //   this.entry.packagingId = this.packagingList[0].id;
          //   clearStorage = clearPackagingAndStorage;
          // }
          // this.selectPackagingInStorage(clearStorage);
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false));
    },
    selectPackagingInStorage: function(clearStorage=false) {
      if (this.entry.packagingId) {
        this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);

        this.loadStorages();
      }
    },
    selectStorageFromList: function() {
      if (this.entry.storageId) {
        this.entry.storage = this.storageList.find(obj => obj.id == this.entry.storageId);        
      }
      
    },
    loadStorages: function(clearStorage) {
      this.clearFields();
      this.entry.itemWeight = {};
      if (clearStorage) {
        this.entry.packagingId = null;
        this.entry.storageId = null;
      }
      this.storageListLoading = true;
      this.$apollo
        .query({
          query: AVAILABLE_ITEMS_FOR_SALE_IN_STORAGE,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            packagingId: this.entry.packagingId
          }
        })
        .then(response => {
          this.storageList = response.data.accountContext.storagesWithAvailableItemForSale;
          this.entry.itemWeight = response.data.accountContext.getItemWeight;
          // console.log("itemweight", this.entry.itemWeight);
          // console.log("this.storageList", this.storageList)
          if (this.storageList.length == 1 && !this.entry.storageId) {
            this.entry.storageId = this.storageList[0].id;
          }
          if (this.entry.storageId) {
            this.selectStorageFromList();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },
    findTablePriceProduct: function() {
      // this.storageListLoading = true;
      this.$apollo
        .query({
          query: FIND_TABLE_PRICE_PRODUCT,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            packagingId: this.entry.packagingId,
            customerId: this.extraData.customerId,
            paymentConditionRuleId: this.extraData.paymentConditionRuleId,
          }
        })
        .then(response => {
          this.tablePriceProduct = response.data.accountContext.findTablePriceProduct;
          console.log("this.tablePriceProduct", this.tablePriceProduct);
          this.tablePriceItem = response.data.accountContext.findTablePriceItem;
          console.log("this.tablePriceItem", this.tablePriceItem);
          if(this.tablePriceItem){
            if(this.manualPackagingPrice){
              this.tablePriceProduct.value = this.entry.packagingPrice;
            }
            if(this.tablePriceItem.percentType == 0 && !this.manualPackagingPrice){
              // console.log("percemnt", this.tablePriceItem.percent);
              if(!this.isEdit){
                this.entry.packagingPrice = _.round (this.tablePriceProduct.value / (1-(this.tablePriceItem.percent/100)), 2);
              }
              // this.entry.unitPrice = this.entry.packagingPrice
            }else{
              if(!this.isEdit){
                this.entry.packagingPrice = this.tablePriceProduct.value;
              }
            }
            this.entry.tablePriceValue = this.entry.packagingPrice;
          }else{
            this.entry.packagingPrice = null;
            // console.log("tablepriceitem not found");
          }
          // this.entry.packagingPrice = this.tablePriceProduct.value;
          this.packagingPriceKey++;

          if(this.entry.discount){
            this.changeDiscount();
          }
          this.changePackagingPrice();
          // this.updateQuantity();
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },
    clearFields: function() {
      this.forceRerender(this);
    },
    storageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.storageId = storage.id;
      this.entry.storage = storage;
    },
  }
};

const END_PRODUCTS_FOR_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableEndProductsForQuery(query: $query) {
        id
        name
        description
        barcode
        typeText
        packagings {
          id
          name
          unitName
        }
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        group {
          id
          name
        }
      }
    }
  }
`;

const AVAILABLE_ITEMS_FOR_SALE_IN_STORAGE = gql `
  query ($itemId: ID!, $packagingId: ID!) {
    accountContext {
      storagesWithAvailableItemForSale(itemId: $itemId, packagingId: $packagingId) {
        id
        name
        availableQuantity
      }
      getItemWeight(itemId: $itemId, packagingId: $packagingId) {
        grossWeight
        liquidWeight
      }
    }
  }
`;

const FIND_TABLE_PRICE_PRODUCT = gql `
  query ($itemId: ID!, $packagingId: ID!, $customerId: ID!, $paymentConditionRuleId: ID!) {
    accountContext {
      findTablePriceProduct(itemId: $itemId, packagingId: $packagingId, customerId: $customerId, paymentConditionRuleId: $paymentConditionRuleId) {
        id
        value
        commissionPercent
      }
      findTablePriceItem(itemId: $itemId, paymentConditionRuleId: $paymentConditionRuleId, customerId: $customerId){
        percent
        percentType
        discountAddition
      }
    }
  }
`;

const ALL_ITEMS_QUERY = gql `
  query($itemsSearch: String!) {
    accountContext {
      allItemsSearch(itemsSearch: $itemsSearch){
        id
        name
        type
        brand{
          name
        }
      }
    }
  }
`;

const AVAILABLE_PACKAGINGS_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $customerId: ID) {
    accountContext {
      availablePackagingsForItem(itemId: $itemId, customerId: $customerId){
        id
        name
        size
        unitName
      }
    }
  }
`;

const AVAILABLE_PACKAGINGS_FOR_SALE_ITEM_QUERY = gql `
  query ($itemId: ID!, $dummyExitMovementItemId: ID) {
    accountContext {
      availableItemPackagingsForSale(itemId: $itemId, dummyExitMovementItemId: $dummyExitMovementItemId){
        id
        name
        size
        unitName
      }
    }
  }
`;


</script>

<style scoped></style>
